export default "__VITE_ASSET__CRLw4r11__"